import React, { useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import FilterListIcon from '@mui/icons-material/FilterAltOutlined';
import RefreshIcon from '@mui/icons-material/Refresh';
import AddUserModal from "../modals/addUserModal";
import RemoveUserModal from "../modals/removeUserModal";
import RoleManagement from "../../security/roleManagement";
import JWTTokenPayload from "../../interfaces/JWTTokenPayload";
import { decodedJWT, getUserRole } from "../../utils/commonUtils";

interface UsersToolbarProps {
    filtersCount: number;
    toggleFilterDrawer: () => void;
    resetFilters: () => void;
    reloadFunction: () => void;
};

const UsersToolbar: React.FC<UsersToolbarProps> = ({ filtersCount, toggleFilterDrawer, resetFilters, reloadFunction }) => {
    const token: false | JWTTokenPayload = decodedJWT();
    const userRole = getUserRole(token);
    const [openAgentModal, setOpenAgentModal] = useState<boolean>(false);
    const [openRemoveUserModal, setOpenRemoveUserModal] = useState<boolean>(false);

    return (
        <Box sx={{ mt: 2, mb: 2, display: 'flex', justifyContent: 'space-between' }}>
            <Box display="flex">
                <Button
                    variant={filtersCount === 0 ? "outlined" : "contained"}
                    color="primary"
                    startIcon={<FilterListIcon fontSize="small" />}
                    onClick={toggleFilterDrawer}
                    aria-label="open drawer"
                >
                    <Typography variant="subtitle2">Filters [{filtersCount}]</Typography>
                </Button>
                <Button
                    style={{ marginLeft: "10px", marginRight: "10px" }}
                    variant="outlined"
                    color="primary"
                    startIcon={<RefreshIcon fontSize="small" />}
                    onClick={resetFilters}
                    aria-label="Refresh"
                >
                    <Typography variant="subtitle2">Reset</Typography>
                </Button>
            </Box>
            <Box display="flex">
                <Button
                    variant="contained"
                    onClick={() => setOpenAgentModal(true)}
                    color='primary'
                    sx={{ marginRight: '10px' }}
                >
                    Add {RoleManagement.isSuperAdmin(userRole) ? 'Admin' : 'User'}
                </Button>

                <Button
                    variant="contained"
                    onClick={() => setOpenRemoveUserModal(true)}
                    color='warning'
                >
                    Remove {RoleManagement.isSuperAdmin(userRole) ? 'Admin' : 'User'}
                </Button>
            </Box>
            <AddUserModal
                openModal={openAgentModal}
                handleCloseModal={() => setOpenAgentModal(false)}
                reloadFunction={reloadFunction}
            />
            <RemoveUserModal
                modalVisible={openRemoveUserModal}
                closeModal={() => setOpenRemoveUserModal(false)}
                reloadFunction={reloadFunction}
            />
        </Box>
    );
};

export default UsersToolbar;